import { ModalWrapper } from '@/core/modal';
import { useTracker } from '@/core/tracking';
import { useLocalization } from '@/services/localizationService';
import { closeModalSelector } from '@/stores/modalStore';
import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import {
  shouldApplyPipelineChanges,
  shouldResetToolbarToImageData,
} from '@/stores/editorStore';

export default function AIModelMismatchModal({
  id,
  openDownloadSidebar,
  ...rest
}: {
  id: string;
  openDownloadSidebar: CallableFunction;
}) {
  const closeModal = useSetRecoilState(closeModalSelector);
  const { t, data } = useLocalization();
  const { track } = useTracker();

  useEffect(() => {
    track('ai_model_mismatch_modal', 'shown');
  }, [track]);

  const setShouldApplyPipeline = useSetRecoilState(shouldApplyPipelineChanges);
  const setShouldResetToolbar = useSetRecoilState(
    shouldResetToolbarToImageData
  );

  return (
    <ModalWrapper className="text-center relative w-80" {...rest}>
      <p className="SB20 text-black my-2">{t(data.result.aiModelMismatch)}</p>

      <p className="M16 text-gray-450 mt-3 mx-1">
        {t(data.result.aiModelMismatchBody)}
      </p>
      <button
        type="button"
        className="w-11/12 btn btn--large shadow-dark-button btn--black mt-7 inline-flex"
        onClick={() => {
          track('ai_model_mismatch_modal', 'accepted');
          closeModal(id);
          setShouldApplyPipeline(true);
        }}
      >
        <span className="SB16">{t(data.common.apply)}</span>
      </button>
      <button
        type="button"
        className="SB16 text-black mt-5 mb-2"
        onClick={() => {
          track('ai_model_mismatch_modal', 'not_accepted');
          closeModal(id);

          setShouldResetToolbar(true);
          openDownloadSidebar();
        }}
      >
        {t(data.common.proceedWithoutApplying)}
      </button>
    </ModalWrapper>
  );
}
